import { toast as sonerToast } from "sonner"

export interface ToastProps {
  title?: string
  description?: string
  variant?: "default" | "destructive"
}

export function toast({ title, description, variant }: ToastProps) {
  if (variant === "destructive") {
    sonerToast.error(title || "", {
      description,
    })
  } else {
    sonerToast.success(title || "", {
      description,
      classNames: {
        description: "!text-slat-400",
      },
    })
  }
}

export { sonerToast }
